import React from 'react';
import AuthContainer from '../components/auth/AuthContainer';

const Register = () => {
  return <AuthContainer initialTab="register" />;
};

export default Register; 